import React from 'react';
import { TextField } from '@mui/material';
import { useAppSelector, useAppDispatch } from '../../../../../app/store';
import { updateSelectedFeeSchedule } from '../../../../../services/ContractService/contractSlice';

const DescriptionEditor: React.FC = () => {
  const dispatch = useAppDispatch();
  const selectedFeeSchedule = useAppSelector((state) => state.contract.currentFeeSchedule);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (selectedFeeSchedule) {
      dispatch(updateSelectedFeeSchedule({
        ...selectedFeeSchedule,
        description: event.target.value
      }));
    }
  };

  return (
    <TextField
      fullWidth
      label="Description"
      value={selectedFeeSchedule?.description || ''}
      onChange={handleChange}
      placeholder="Enter fee schedule description"
      size="small"
      variant="outlined"
    />
  );
};

export default DescriptionEditor;
